import { UserStatus } from "@/models/user-status.model";
import type { UserListItem } from "@/models/user.model";
import { useConfirmDialogStore } from "@/shared/stores";
import { DropdownCell } from "@spz/ui/components/table/cells/dropdown-cell";
import { useTranslation } from "react-i18next";
import { useUpdateUserStatus } from "../../hooks/use-update-user-status";

type StatusDropdownCellProps = {
  status: UserStatus;
  user: UserListItem;
};

export const StatusDropdownCell = ({
  user,
  status,
}: StatusDropdownCellProps) => {
  const { t } = useTranslation();
  const { openDialog, closeDialog } = useConfirmDialogStore();
  const { updateUserStatus } = useUpdateUserStatus();
  const options = UserStatus.getOptions(status).map((option) => ({
    value: option.value,
    label: t(option.labelKey),
    description: option.descriptionKey ? t(option.descriptionKey) : undefined,
    disabled: option.disabled,
  }));

  const handleChange = (value: string) => {
    const newStatus = UserStatus.fromValue(value);
    if (newStatus === status) return;

    const confirmationTitleKey = newStatus.confirmationTitleKey;
    const confirmationDescriptionKey = newStatus.confirmationDescriptionKey;

    if (!confirmationTitleKey || !confirmationDescriptionKey) {
      return;
    }

    openDialog({
      title: t(confirmationTitleKey),
      description: t(confirmationDescriptionKey, {
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
      }),
      onConfirm: () => {
        updateUserStatus({ userId: user.id, status: newStatus });
        closeDialog();
      },
    });
  };

  return (
    <DropdownCell
      options={options}
      value={status.value}
      onChange={handleChange}
    />
  );
};
